import { render, staticRenderFns } from "./unlimitedTier.vue?vue&type=template&id=89c2bf2a&scoped=true"
import script from "./unlimitedTier.vue?vue&type=script&setup=true&lang=js"
export * from "./unlimitedTier.vue?vue&type=script&setup=true&lang=js"
import style0 from "./unlimitedTier.vue?vue&type=style&index=0&id=89c2bf2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c2bf2a",
  null
  
)

export default component.exports